// import React, { useState } from "react";
// import { useDispatch } from "react-redux";
// import {
//   Button,
//   TextField,
//   Box,
//   Typography,
//   Grid,
//   Paper,
//   MenuItem,
//   Select,
//   InputLabel,
//   FormControl,
// } from "@mui/material";
// import { reportBug } from "../../redux/bugs/bugSlice";

// const BugReportForm = () => {
//   const dispatch = useDispatch();
//   const [bugData, setBugData] = useState({
//     module_name: "",
//     page_name: "",
//     page_url: "",
//     browser_name: "",
//     comment: "",
//     images: [],
//   });

//   // Convert file to Base64
//   const handleImageUpload = (event) => {
//     const files = event.target.files;
//     const promises = [];

//     for (let i = 0; i < files.length; i++) {
//       promises.push(
//         new Promise((resolve, reject) => {
//           const reader = new FileReader();
//           reader.onload = () => resolve(reader.result);
//           reader.onerror = (error) => reject(error);
//           reader.readAsDataURL(files[i]);
//         })
//       );
//     }

//     Promise.all(promises)
//       .then((base64Images) => {
//         setBugData((prev) => ({
//           ...prev,
//           images: [...prev.images, ...base64Images],
//         }));
//       })
//       .catch((err) => console.error("Image Upload Error:", err));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     dispatch(reportBug(bugData));
//   };

//   const handleChange = (e) => {
//     setBugData({ ...bugData, [e.target.name]: e.target.value });
//   };

//   return (
//     <Grid
//       container
//       justifyContent="center"
//       alignItems="center"
//       style={{ minHeight: "100vh" }}
//     >
//       <Grid item xs={12} sm={8} md={6}>
//         <Paper elevation={3} sx={{ p: 4, borderRadius: 4 }}>
//           <Typography variant="h4" align="center" gutterBottom>
//             Report a Bug
//           </Typography>
//           <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
//             <TextField
//               label="Module Name"
//               name="module_name"
//               fullWidth
//               variant="outlined"
//               margin="normal"
//               value={bugData.module_name}
//               onChange={handleChange}
//               required
//             />
//             <TextField
//               label="Page Name"
//               name="page_name"
//               fullWidth
//               variant="outlined"
//               margin="normal"
//               value={bugData.page_name}
//               onChange={handleChange}
//               required
//             />
//             <TextField
//               label="Page URL"
//               name="page_url"
//               fullWidth
//               variant="outlined"
//               margin="normal"
//               value={bugData.page_url}
//               onChange={handleChange}
//               required
//             />

//             {/* Browser Dropdown */}
//             <FormControl fullWidth margin="normal">
//               <InputLabel>Browser Name</InputLabel>
//               <Select
//                 name="browser_name"
//                 value={bugData.browser_name}
//                 onChange={handleChange}
//                 required
//               >
//                 <MenuItem value="Chrome">Chrome</MenuItem>
//                 <MenuItem value="Firefox">Firefox</MenuItem>
//                 <MenuItem value="Edge">Edge</MenuItem>
//                 <MenuItem value="Safari">Safari</MenuItem>
//                 <MenuItem value="Opera">Opera</MenuItem>
//               </Select>
//             </FormControl>

//             <TextField
//               label="Comment"
//               name="comment"
//               fullWidth
//               multiline
//               rows={4}
//               variant="outlined"
//               margin="normal"
//               value={bugData.comment}
//               onChange={handleChange}
//               required
//             />

//             {/* Image Upload */}
//             <Button
//               variant="outlined"
//               component="label"
//               sx={{ mt: 2, display: "block" }}
//             >
//               Upload Images
//               <input
//                 type="file"
//                 multiple
//                 hidden
//                 accept="image/*"
//                 onChange={handleImageUpload}
//               />
//             </Button>

//             {/* Image Previews */}
//             <Box sx={{ display: "flex", gap: 2, mt: 2, flexWrap: "wrap" }}>
//               {bugData.images.map((image, index) => (
//                 <img
//                   key={index}
//                   src={image}
//                   alt={`Bug Image ${index + 1}`}
//                   style={{
//                     width: 80,
//                     height: 80,
//                     objectFit: "cover",
//                     borderRadius: 8,
//                     border: "1px solid #ddd",
//                   }}
//                 />
//               ))}
//             </Box>

//             <Button
//               type="submit"
//               fullWidth
//               variant="contained"
//               color="primary"
//               sx={{ mt: 3, py: 1.5, borderRadius: 2 }}
//             >
//               Submit Bug Report
//             </Button>
//           </Box>
//         </Paper>
//       </Grid>
//     </Grid>
//   );
// };

// export default BugReportForm;

import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Button,
  TextField,
  Box,
  Typography,
  Grid,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Drawer,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { reportBug } from "../../redux/bugs/bugSlice";

const BugReportFormDrawer = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const [bugData, setBugData] = useState({
    module_name: "",
    page_name: "",
    page_url: "",
    browser_name: "",
    comment: "",
    images: [],
  });

  const handleImageUpload = (event) => {
    const files = event.target.files;
    const promises = [];

    for (let i = 0; i < files.length; i++) {
      promises.push(
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(files[i]);
        })
      );
    }

    Promise.all(promises)
      .then((base64Images) => {
        setBugData((prev) => ({
          ...prev,
          images: [...prev.images, ...base64Images],
        }));
      })
      .catch((err) => console.error("Image Upload Error:", err));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(reportBug(bugData));
    onClose(); // Close the drawer after submission
    setBugData({
      module_name: "",
      page_name: "",
      page_url: "",
      browser_name: "",
      comment: "",
      images: [],
    }); // Reset form data
  };

  const handleChange = (e) => {
    setBugData({ ...bugData, [e.target.name]: e.target.value });
  };

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDrawer-paper": {
          width: "100%", // Full width
          height: "80%", // 80% of the screen height
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          padding: 3,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h5">Report a Bug</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Bug Report Form */}
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Module Name"
              name="module_name"
              fullWidth
              variant="outlined"
              value={bugData.module_name}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Page Name"
              name="page_name"
              fullWidth
              variant="outlined"
              value={bugData.page_name}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Page URL"
              name="page_url"
              fullWidth
              variant="outlined"
              value={bugData.page_url}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Browser Name</InputLabel>
              <Select
                name="browser_name"
                value={bugData.browser_name}
                onChange={handleChange}
                required
              >
                <MenuItem value="Chrome">Chrome</MenuItem>
                <MenuItem value="Firefox">Firefox</MenuItem>
                <MenuItem value="Edge">Edge</MenuItem>
                <MenuItem value="Safari">Safari</MenuItem>
                <MenuItem value="Opera">Opera</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Comment"
              name="comment"
              fullWidth
              multiline
              rows={4}
              variant="outlined"
              value={bugData.comment}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <Button variant="outlined" component="label" fullWidth>
              Upload Images
              <input
                type="file"
                multiple
                hidden
                accept="image/*"
                onChange={handleImageUpload}
              />
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ display: "flex", gap: 2, mt: 2, flexWrap: "wrap" }}>
              {bugData.images.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`Bug Image ${index + 1}`}
                  style={{
                    width: 80,
                    height: 80,
                    objectFit: "cover",
                    borderRadius: 8,
                    border: "1px solid #ddd",
                  }}
                />
              ))}
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              sx={{ py: 1.5 }}
            >
              Submit Bug Report
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Drawer>
  );
};

export default BugReportFormDrawer;
